import { Cascader } from "antd";
const formatOption = (o) => {
  o.label = o.label || o.name;
  o.value = o.value || o.id;
  if (o.children) {
    o.children = o.children.map(formatOption);
  }
  return o;
};
export default function FieldCascader({
  field,
  value,
  placeholder,
  onChange,
  opts = {},
  options = [],
}) {
  let _options = (options || []).map(formatOption);
  return (
    <Cascader
      name={field}
      value={value}
      placeholder={placeholder || "请输入"}
      onChange={onChange}
      options={_options}
      {...opts}
    />
  );
}
